export default "__VITE_ASSET__BflW4$sn__"